import { render, staticRenderFns } from "./captions.vue?vue&type=template&id=8c968a2e&scoped=true&"
import script from "./captions.vue?vue&type=script&lang=js&"
export * from "./captions.vue?vue&type=script&lang=js&"
import style0 from "./captions.vue?vue&type=style&index=0&id=8c968a2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../RetirementPlanner.Demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c968a2e",
  null
  
)

export default component.exports